

exports.__esModule = true;

var _route = require('./route');

Object.keys(_route).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _route[key];
    }
  });
});


//////////////////
// WEBPACK FOOTER
// ./pages/xo-pay/index.js
// module id = ./pages/xo-pay/index.js
// module chunks = 0